module.exports = __webpack_public_path__ + "47c2cdb7c99bcbd93be794a7cd1925da.svg";